import(/* webpackMode: "eager" */ "/src/web-app/src/app/loading.tsx");
